import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { handleResponse } from "@/utils/errorResponseHandlers";
import { ENDPOINTS } from "@/api/application-api";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useCreateCustomModel = (authToken: string) => {
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mutationFn: async (modelInfo: any) => {
      const response = await fetch(ENDPOINTS.models(String(workspaceId)), {
        method: "POST",
        headers: jsonAuthHeaders(authToken),
        body: JSON.stringify(modelInfo),
      });
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["models", workspaceId],
      });
    },
    onError: (error: string) => {
      displayErrorToast(error);
    },
  });
};
